import ResultFormatterBase from "../ResultFormatterBase.js";
import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import * as Enums from "../../enums/index.js";
import EnumValueProvider from "../../providers/EnumValueProvider.js";

class EnumValuesFormatter extends ResultFormatterBase{
    constructor(targetParams, newStructurePath) {
        super();
        if (!(targetParams instanceof Array)){
            throw new TypeError('targetEnums must be an array');
        }

        if (typeof(newStructurePath) !== 'undefined' && !(newStructurePath instanceof Array)) {
            throw new TypeError('newStructurePath must be undefined or array');
        }

        this.newStructurePath = newStructurePath;
        this.pathPerParameter = EnumValuesFormatter.getParametersPaths(targetParams, newStructurePath);
    }

    static getParametersPaths(parameters, newStructurePath) {
        const paths = new Map();
        const enumValues = new Map();
    
        for (let singleEnum in Enums){
            enumValues.set(singleEnum, Object.values(Enums[singleEnum]));
        }
    
        for (let i = 0; i < parameters.length; i++) {
            const parameter = parameters[i];
    
            for (let [singleParam, paramDefinition] of enumValues) {
                if (!paramDefinition.includes(parameter)) {
                    continue;
                }
    
                if (singleParam === Enums.ResultData || singleParam === Enums.ResultDataNew) {
                    paths.set(parameter, [parameter.key]);
                }
                else {
                    if (newStructurePath) {
                        paths.set(parameter, Enums.ResultDataNew.getDataPath(parameter.key, newStructurePath[0], newStructurePath[1]));
                    }
                    else {
                        paths.set(parameter, Enums.ResultData.getDataPath(parameter.key));
                    }
                }
            }
        }
    
        return paths;
    }

    format(result) {
        const dataProp = this.newStructurePath ? Enums.ResultDataNew.Data.key: Enums.ResultData.Data.key;
        if (!result || !result.hasOwnProperty(dataProp) || !result[dataProp]){
            return result;
        }

        for (let [parameter, path] of this.pathPerParameter){
            if (!parameter.hasOwnProperty('enum')){
                continue;
            }

            const currentValue = IterableDataProcessor.getObjectContent(result, path);
            if (typeof(currentValue) === 'undefined'){
                // TODO - maybe log if there is no default value ?
                continue;
            }

            const mappedValue = EnumValueProvider.getValue(currentValue, parameter.enum, parameter.enumDefault, false);
            if (mappedValue && mappedValue.hasOwnProperty('key') && currentValue !== mappedValue.key){
                IterableDataProcessor.setObjectContent(result, path, mappedValue.key);
            }
        }

        return result;
    }
}

export default EnumValuesFormatter;